import { ReactNode } from 'react'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { OdinStatusBadge } from '@/components/ui/odin/odin-status-badge'
import { OdinIcon } from '@/components/ui/odin/odin-icon'

type MessageSectionProps = {
  icon: IconProp
  title: string
  count: number
  /** Sections are collapsed by default so the message stays clean. */
  defaultOpen?: boolean
  children: ReactNode
}

export const MessageSection = ({ icon, title, count, defaultOpen = false, children }: MessageSectionProps) => (
  <Collapsible defaultOpen={defaultOpen} className="mt-3 border-t border-border pt-2">
    <CollapsibleTrigger className="group flex w-full cursor-pointer items-center gap-2 select-none">
      <OdinStatusBadge circle variant="info" icon={icon} />
      <span className="min-w-0 truncate text-sm font-semibold text-foreground">{title}</span>
      <span className="text-xs text-muted-foreground">({count})</span>
      <OdinIcon
        icon={['far', 'chevron-down']}
        className="ml-auto size-3 shrink-0 text-muted-foreground transition-transform duration-300 group-data-[panel-open]:rotate-180 motion-reduce:transition-none"
      />
    </CollapsibleTrigger>
    <CollapsibleContent className="h-[var(--collapsible-panel-height)] overflow-hidden transition-[height] duration-300 ease-out data-[ending-style]:h-0 data-[starting-style]:h-0 motion-reduce:transition-none">
      <div className="pt-2">{children}</div>
    </CollapsibleContent>
  </Collapsible>
)
